<template>
  <component
    :is="LoginComponent"
    @back="$emit('back')"
    @success="$emit('success', $event)"
    @accountSelect="$emit('accountSelect', $event)"
    @switch="$emit('switch', $event)"
  />
</template>

<script lang="ts" setup>
import ForeignLogin from './Foreign.vue';
import InlandLogin from './Inland.vue';

defineEmits<{
  back: [...args: any[]];
  success: [...args: any[]];
  accountSelect: [...args: any[]];
  switch: [...args: any[]];
}>();

const LoginComponent = computed(() => {
  return isGlobalVersion() ? ForeignLogin : InlandLogin;
});
</script>
